import React, {Component} from "react";
import {Modal} from "antd";
import { injectIntl } from 'react-intl';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import connect from "react-redux/es/connect/connect";
import IntlTelInput from 'react-intl-tel-input';
import SelectSender from "../../SelectSender/SelectSender";
import { changeConversationSender, createConversation, setChatId, turnScrollOn } from "../../../../appRedux/actions";
import {getConversationByNumber} from "../utils";
import {addFrontPlusIfMissing} from "../../../../util/helpers";
import PhoneNumberInput from "../PhoneNumberInput/PhoneNumberInput";
import './NewConversationModal.scss';
import { isShoperApp } from "../../../../util/appType";
import { numberCheck } from "../../../../util/numberCheck";
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled } from "@ant-design/icons";

class NewConversationModal extends Component {
  state = {
    wrongFormatError: '',
    newNumber: '',
    newNumberCountryCallingCode: '48',
    newNumberCountryCode: 'PL',
    senderNumber: ''
  };

  componentDidMount() {
    const defaultNumber = this.props.accounts.phoneNumbersAll.find(entry => entry.isDefault);
    this.updateSenderNumber(
        defaultNumber ? defaultNumber.number : this.props.accounts.phoneNumbersAll[0]?.number
    );
  }

  onModalOk = () => {
    const number = parsePhoneNumberFromString(addFrontPlusIfMissing(this.state.newNumber));

    if (!number?.isValid()) {
      this.wrongFormat();
      return false;
    }

    const countryCodeAndNumber = number.countryCallingCode + number.nationalNumber;
    const existingConversation = getConversationByNumber(this.props.conversations, countryCodeAndNumber);

    if (existingConversation) {
      this.setState({
        newNumber: '',
        wrongFormatError: ''
      }, () => {
        this.props.setChatId(existingConversation._id);
        this.props.changeConversationSender(this.state.senderNumber, countryCodeAndNumber)
        this.props.hideNewConversationModal();
        this.props.turnScrollOn();
      });
    } else {
      this.props.createConversation(countryCodeAndNumber, this.state.senderNumber ? this.state.senderNumber : this.props.accounts.phoneNumbersAll[0].number);
      this.setState({
        newNumber: '',
        wrongFormatError: ''
      }, () => {
        this.props.setChatId(this.props.conversations[this.props.conversations.length-1]._id);
        this.props.hideNewConversationModal();
        this.props.turnScrollOn();
      });
    }
  };

  wrongFormat = () => {
    this.setState({
      wrongFormatError: this.props.intl.formatMessage({id: 'chats.wrongPhoneNumber'})
    });
  };

  updateNewNumber = number => this.setState({newNumber: number});

  updateNewNumberFromIntlTelInput = (isValid, newNumber, selectedCountryData, fullNumber) => {
    this.setState({newNumber: fullNumber});
  };

  updateSenderNumber = newNumber => {
    this.setState({senderNumber: newNumber});
    this.setPrefixClientPhoneNumber(newNumber);
  };

  setPrefixClientPhoneNumber = senderNumber => {
      const senderNumberObject = parsePhoneNumberFromString(`+${senderNumber}`);

      if (senderNumberObject && senderNumberObject.country !== this.state.newNumberCountryCode) {
          this.setState({
              newNumberCountryCallingCode: senderNumberObject.countryCallingCode,
              newNumberCountryCode: senderNumberObject.country
          });
      }
  };

  getSenderCustomName = () =>this.props.accounts?.phoneNumbersAll?.find(item =>  item.number === this.state.senderNumber)?.customName;

  // What the typed number is: mobile (fine), not mobile (red; only a warning in North America, where
  // landlines can take texts) or not a valid number.
  checkText = check => {
    const t = (id, defaultMessage, values) => this.props.intl.formatMessage({id, defaultMessage}, values);
    switch (check.code) {
      case 'MOBILE': return t('chats.number.mobile', 'Mobile number');
      case 'MOBILE_OR_LANDLINE': return check.nanp
        ? t('chats.number.valid', 'Valid number')
        : t('chats.number.mobileOrLandline', 'Valid number (mobile or landline: this country does not tell them apart)');
      case 'NANP_NOT_MOBILE': return t('chats.number.nanpLandline', 'Looks like a {type} number. In the US and Canada texts to text-enabled landlines can still arrive.', {type: check.label || 'non-mobile'});
      case 'NOT_MOBILE': return t('chats.number.notMobile', 'Not a mobile number ({type}): text messages will most likely not arrive.', {type: check.label || '?'});
      case 'UNKNOWN_RANGE': return t('chats.number.unknownRange', 'Not a mobile number range: it may be an M2M / IoT or unassigned number, so text messages will most likely not arrive.');
      case 'TOO_LONG': return t('chats.number.tooLong', 'Too many digits for this country');
      default: return t('chats.number.invalid', 'Not a valid phone number for this country');
    }
  };

  render() {
    const t = (id, defaultMessage) => this.props.intl.formatMessage({id, defaultMessage});
    const check = numberCheck(this.state.newNumber);
    const Icon = check?.level === 'ok' ? CheckCircleFilled : check?.level === 'warn' ? ExclamationCircleFilled : CloseCircleFilled;
    return (
      <Modal
        title={this.props.intl.formatMessage({id: 'chats.enterPhoneNumber'})}
        toggle={this.props.hideNewConversationModal}
        visible={this.props.visible}
        closable={false}
        onOk={this.onModalOk}
        onCancel={this.props.hideNewConversationModal}
        width={460}
        className={`new-chat-modal${isShoperApp() ? " shoper-modal" : ""}`}
      >
        <div className="new-chat">
          <div className={`new-chat__number${check ? ` is-${check.level}` : ''}`}>
            {this.getSenderCustomName() ? (
              <IntlTelInput
                  nationalMode={false}
                  value={this.state.newNumber || `+${this.state.newNumberCountryCallingCode}`}
                  format={true}
                  onPhoneNumberChange={this.updateNewNumberFromIntlTelInput}
                  />
            ) : (
              <PhoneNumberInput
                  countryCode={this.state.newNumberCountryCode}
                  callingCode={this.state.newNumberCountryCallingCode}
                  onClientNumberChange={this.updateNewNumber}
                  clearValue={!this.state.newNumber}
              />
            )}
          </div>
          {check ? (
            <div className={`new-chat__check is-${check.level}`} role={check.level === 'ok' ? 'status' : 'alert'}>
              <Icon aria-hidden="true"/>
              <span>{this.checkText(check)}</span>
            </div>
          ) : this.state.wrongFormatError ? (
            <div className="new-chat__check is-err" role="alert">
              <CloseCircleFilled aria-hidden="true"/>
              <span>{this.state.wrongFormatError}</span>
            </div>
          ) : null}

          <div className="new-chat__sender">
            <span className="new-chat__label">{t('chats.sendFrom', 'Send from')}</span>
            <SelectSender
              selectedValue={this.state.senderNumber}
              senderList={this.props.accounts.phoneNumbersAll}
              updateSenderNumber={this.updateSenderNumber}
            />
          </div>
        </div>
      </Modal>
    );
  }
}


const mapStateToProps = (state) => ({
  accounts: state.accounts,
  conversations: state.messages,
});

export default injectIntl(connect(mapStateToProps, {
  createConversation,
  changeConversationSender,
  setChatId,
  turnScrollOn
})(NewConversationModal));
